import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=920d29b8&scoped=true"
import script from "./Licenses.vue?vue&type=script&lang=ts"
export * from "./Licenses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d29b8",
  null
  
)

export default component.exports